import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { initialState as customerInitialState } from '~redux/slices/gold';

import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';

import * as Styles from './_branchInventorySearchAndFilterbar.module.scss';
import { BranchStatusEnum } from '~utils/enums';

const BranchInventorySearchAndFilterBar = () => {
    const dispatch = useAppDispatch();

    const filters = useAppSelector(state => state.gold.goldInventoryReport.branchInventory.filters);
    const { allBranchAccess, branchCode } = useAppSelector(state => state.auth.userDetails);
    const branchesList = useAppSelector(state => state.branch.allBranches);

    const branchOptions = branchesList.filter(branch => branch.status === BranchStatusEnum.Active);

    const setFilters = (branchName: string) => dispatch(combinedActions.goldSetBranchInventoryListingFilters({ branchName }));
    const clearFilters = () => dispatch(combinedActions.goldClearBranchInventoryListingFilters());
    const handleSearchClick = () => {
        const branchId = branchOptions.find(branch => branch.branchName === filters.branchName)?.branchId;
        dispatch(combinedActions.goldGetBranchInventoryListingAttempt());
        dispatch(combinedActions.goldGetInventoryUsageAttempt(branchId ? { branchId } : undefined));
    };

    useEffect(() => {
        if (branchOptions.length > 0 && !allBranchAccess) {
            setFilters(branchOptions.find((branch) => branch.branchCode === branchCode)?.branchName || '');
        }
    }, [branchesList]);

    const handleCancelClick = () => {
        clearFilters();
        dispatch(combinedActions.goldGetBranchInventoryListingAttempt());
        dispatch(combinedActions.goldGetInventoryUsageAttempt(undefined));
    };

    const massagedBranchesListOption = () => {
        if (!branchOptions.length) return [];

        return branchOptions.map((branch) => ({
            label: branch.branchName,
            value: branch.branchCode,
        }));
    };

    const fields: TSearchAndFilterBarProps['fields'] = [
        {
            label: 'Choose branch to view:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: massagedBranchesListOption(),
                value: filters.branchName || '',
                setValue: (event: React.ChangeEvent<HTMLInputElement>) => setFilters(
                    event.target.value,
                ),
                optionSelected: !!branchOptions.find((branch) => branch.branchName === filters.branchName),
                noOptionsMessage: 'No branches found',
                className: Styles.input,
                disabled: !allBranchAccess,
            },
        },
    ];

    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
        />
    );
};

export default BranchInventorySearchAndFilterBar;
